import { page } from "../page-copy";
import { revealHostProps } from "../reveal-host";
import CostFigure from "./CostFigure";
import EcosystemFigure from "./EcosystemFigure";
import KeepFigure from "./KeepFigure";
import ReactLogo from "./ReactLogo";

export default function Why({ start, step }: { start: number; step: number }) {
  const a = page.why[0];
  const b = page.why[1];
  const reveal0 = revealHostProps(start);
  const reveal1 = revealHostProps(start + step);

  return (
    <section className="story" aria-label="Why JetShake">
      <div
        className={`${reveal0.className} story-block`}
        style={reveal0.style}
        onAnimationEnd={reveal0.onAnimationEnd}
      >
        <h2 className="story-heading">
          <ReactLogo className="story-react-logo" />
          {a.heading}
        </h2>
        <div className="story-stack">
          <p className="story-p">{a.paragraphs[0]}</p>
          <p className="story-p">{a.paragraphs[1]}</p>
        </div>
        <EcosystemFigure />
        <div className="story-after">
          <div className="story-stack">
            <p className="story-p">{a.afterFigure![0]}</p>
          </div>
        </div>
      </div>

      <div
        className={`${reveal1.className} story-block`}
        style={reveal1.style}
        onAnimationEnd={reveal1.onAnimationEnd}
      >
        <h2 className="story-heading">{b.heading}</h2>
        <div className="story-stack">
          <p className="story-p">{b.paragraphs[0]}</p>
          <p className="story-p">{b.paragraphs[1]}</p>
          <p className="story-p story-p--gap">{b.paragraphs[2]}</p>
          <p className="story-p story-p--punch story-p--gap">
            {b.paragraphs[3]}
          </p>
        </div>
        <CostFigure />
      </div>
    </section>
  );
}

export function Pivot({ delay }: { delay: number }) {
  const { pivot } = page;
  const reveal = revealHostProps(delay);
  return (
    <div
      className={`${reveal.className} pivot`}
      style={reveal.style}
      onAnimationEnd={reveal.onAnimationEnd}
    >
      <h2 className="pivot-heading">
        <span className="pivot-heading-primary">{pivot.heading.primary}</span>{" "}
        <span className="pivot-heading-secondary">{pivot.heading.secondary}</span>
      </h2>
      <p className="pivot-line">{pivot.lines[0]}</p>
      <p className="pivot-line">{pivot.lines[1]}</p>
      <p className="pivot-line">{pivot.lines[2]}</p>
      <KeepFigure />
    </div>
  );
}
